module.exports = __webpack_public_path__ + "static/media/list.1f88dbf3.svg";